// extracted by mini-css-extract-plugin
export default {"alertTemplateContainer":"AlertProvider_alertTemplateContainer__Mw4a-"};